import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import "../../assets/css/Home.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useParams } from "react-router-dom";
import Error from "../Error";
const ColorButton = styled((props) => <Button variant="outlined" {...props} />)(
  {
    color: "rgb(217, 188, 169)",
    borderRadius: "30px",
    height: "50px",
    border: "1px solid rgb(217, 188, 169)",
    "&:hover": {
      border: "1px solid rgb(217, 188, 169)",
      background: "rgb(217, 188, 169,0.07)",
    },
  }
);
const NotFound = () => {
  return <Error />;
};
const CreateNew = (props) => {
  const { id } = useParams();
  const event = props.update
    ? props.update.find((obj) => parseInt(obj.id) == parseInt(id))
    : null;
  if (props.currentUser.userId != parseInt(event?.userId) && props.update) {
    return <NotFound />;
  }
  return (
    <div>
      <div
        className="content-header"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          height: "100px",
        }}
      >
        <div
          className="content-header"
          style={{
            height: "100px",
            width: "90%",
            alignItems: "center",
            boxShadow: "none",
          }}
        >
          <ColorButton
            href={
              (window.location.href.toString().includes("new") ||
                window.location.href.toString().includes("update")) &&
              !window.location.search.includes("back=1")
                ? "/app/events"
                : "/app/new"
            }
            startIcon={<ChevronLeftIcon />}
          >
            Back
          </ColorButton>
          <div className="content-head">
            <div className="top">
              <div
                className="flex"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginRight: "10%",
                }}
              >
                <h2>Create New Event</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <props.display
        {...props}
        currentUser={props.currentUser.userId}
        decodedToken={props.currentUser}
        details={props.currentUser}
      />
    </div>
  );
};

export default CreateNew;
